import LoadingButton from 'baby-ui/compounds/LoadingButton'
import { observer } from 'mobx-react-lite'
import { track, useTracking } from 'lib/babylistHealthAnalytics'
import { useMutation } from 'react-query'
import { PlainProductStateModelType, useDMEStore } from '../../store'
import { ProductListingWidgetProps } from './ProductListingWidget'
import { STORE_NAME } from '../../constants'
import { addToCart } from '../../requests'
import { addedToCartEvent } from '../../events'

const DEFAULT_CTA = 'Add To Cart'

export interface CardActionWidgetProps
  extends Pick<ProductListingWidgetProps, 'onAfterAddToCart'> {
  product: PlainProductStateModelType
  cta?: string
}

export default observer(
  ({ onAfterAddToCart, product, cta = DEFAULT_CTA }: CardActionWidgetProps) => {
    const store = useDMEStore()
    const tracker = useTracking()
    const [addToCartMutation, { isLoading }] = useMutation(addToCart, {
      onSuccess: addToCartSucceeded,
      onError: addToCartFailed,
    })

    function addToCartSucceeded(response: { cart: APIResponse.Cart }) {
      store.cart.setLastItemAdded(response.cart, product.id!)
      store.saveSnapshotToLocalStorage()
      fireAddedToCartEvent()
      onAfterAddToCart()
    }

    function addToCartFailed(e: any) {
      store.ui.globalComponents.Snackbar.show(e.message)
      tracker.trackEvent({
        event: track.errorThrown,
        eventLocation: track.EventLocation.NONE,
        storeName: STORE_NAME,
        error: JSON.stringify(e),
      })
    }

    const addProductToCart = () => {
      store.cart.product.update({ id: product.id!, price: product.price! })
      addToCartMutation({
        cartItem: { productId: product.id!, quantity: 1 },
      })
    }

    function fireAddedToCartEvent() {
      addedToCartEvent(tracker)({
        location: track.EventLocation.PLP,
        productId: product.id as number,
        price: product.price as number,
      })
    }

    return (
      <LoadingButton
        fullWidth
        color="primary"
        disabled={isLoading}
        loading={isLoading && store.cart.product.id === product.id}
        size="small"
        variant="contained"
        onClick={addProductToCart}
      >
        {cta}
      </LoadingButton>
    )
  }
)
